import { createUrl } from "../create-url";
import { TRoute, TRoutes } from "../routes.types";

export const website = {
  articles: {
    index: ({ config }: TRoute = {}) => createUrl("/articles", {
      ...config,
    }),
    show: ({ params, config }: TRoute<
      { slug: string }
    >) => createUrl(
      "/articles/{slug}",
      {
        ...config,
        pathParams: params,
      },
    ),
  },
  referAFriend: ({ config }: TRoute<undefined, { situation?: string }> = {}) =>
    createUrl("/refer-a-friend", config),
  customer: ({ config }: TRoute = {}) =>
    createUrl("/customer", config),
  signUp: {
    fresh: ({ config }: TRoute = {}) =>
      createUrl("/sign-up/fresh", config),
  },
  whyFresh: ({ config }: TRoute = {}) =>
    createUrl("/why-fresh", config),
  aboutUs: ({ config }: TRoute = {}) =>
    createUrl("/about-us", config),
  products: ({ config }: TRoute = {}) =>
    createUrl("/products", config),
  breeder: ({ config }: TRoute = {}) =>
    createUrl("/breeder", config),
  login: ({ config }: TRoute = {}) =>
    createUrl("/login", config),
  sitemap: ({ config }: TRoute = {}) =>
    createUrl("/sitemap", config),
  legal: {
    terms: ({ config }: TRoute = {}) =>
      createUrl("/legal/terms", config),
    privacyPolicy: ({ config }: TRoute = {}) =>
      createUrl("/legal/privacy-policy", config),
  },
  flows: {
    cancellation: ({ params, config }: TRoute<
      { subscriptionId: string },
      { redirect?: string | null }
    >) => createUrl(
      "/customer/my-plans/cancel/{subscriptionId}/delay",
      {
        ...config,
        pathParams: params,
      },
    ),
    fresh: {
      add: () => createUrl(
        "/forms/fresh-existing-user",
      ),
    },
    scoop: {
      planet: {
        add:  () => createUrl(
          "/forms/scoop-planet-existing-user",
        ),
        precancellation: ({ params, config }: TRoute<
          { subscriptionId: string }
        >) => createUrl(
          "/pre-cancellation-scoop-planet",
          {
            ...config,
            query: {
              subscriptionId: params.subscriptionId,
              subscription: params.subscriptionId,
              addonPlanType: "PLANET_SCOOP_LITTER",
            },
          },
        ),
      },
    },
  },
  surveys: {
    health: () => createUrl("/surveys/health"),
  },
} satisfies TRoutes;
